import { jwtDecode } from "jwt-decode";

/**
 * Returns the user_id to use for data access (Firestore, etc.)
 * @param {boolean} personal - if true, always returns the member's own user_id
 * By default, in workspace mode, returns the account the workspace token is
 * for: the owner's user_id, or one of the owner's sub-accounts when the member
 * switched into it (the token's user_id is that sub-account, workspace_id stays
 * the owner).
 */
function getActiveUserId(personal = false) {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  if (personal) return userData?.user_id;
  if (userData?.workspace_id) {
    try {
      const tokenUserId = jwtDecode(localStorage.getItem("token") || "")?.user_id;
      if (tokenUserId) return tokenUserId;
    } catch (e) {}
    return userData.workspace_id;
  }
  return userData?.user_id;
}

export default getActiveUserId;
